module.exports = __webpack_public_path__ + "static/img/wechat-duodian.1c9e8ec7.svg";